import styled from "styled-components";

const DEFAULT_MENU_HIGHLIGHT = "#10b981";

const menuHighlightColor = props =>
  props.sidebarTheme?.buttonColor || DEFAULT_MENU_HIGHLIGHT;

const sidebarMenuTextColor = props => {
  if (props.themeSetting.sidebarTransParentValue === "on") {
    return "white";
  }
  if (props.sidebarTheme?.textColor) {
    return props.sidebarTheme.textColor;
  }
  return isDarkSidebar(props) ? "rgba(255, 255, 255, 0.78)" : "#64748b";
};

const isDarkSidebar = props => {
  const bg = String(props.sidebarTheme?.backgroundColor || "").toLowerCase();
  const name = props.sidebarTheme?.themeName || "";
  if (name === "light") return false;
  if (bg === "#fff" || bg === "#ffffff") return false;
  if (bg.includes("f5f7fa") || bg.includes("#fff")) return false;
  return true;
};

const SidebarWrapper = styled.div`
    .close-drawer-icon {
        display: none;
        position: absolute;
        right: 15px;
        top: 18px;
        font-size: 20px;
        z-index: 5
        cursor: pointer;
        color: ${props =>
          props.themeSetting.sidebarTransParentValue === "on"
            ? "white"
            : props.sidebarTheme.textColor} !important;
    }

    .sidebar-scrollbar-style {
        position: relative;
        display: block;
        width: 100%;
        cursor: pointer;
        border-radius: inherit;
        background-color: rgba(0, 0, 0, 0.2);
        height: 206px;
        transform: translateY(0px);
        background-color: ${props =>
          props.themeSetting.sidebarTransParentValue === "on"
            ? "white"
            : props.sidebarTheme.textColor} !important;
        opacity: 0.4;
    }

    .sidelist-header-name {
        text-transform: uppercase !important;
        font-weight: 700;
        display: flex;
        width: 100%;
        padding: 0.4rem 1rem 0.25rem;
        margin: 16px 0 4px;
        color: ${props =>
          isDarkSidebar(props)
            ? "rgba(255,255,255,0.45)"
            : props.themeSetting.sidebarTransParentValue === "on"
            ? "rgba(255,255,255,0.45)"
            : "#94a3b8"} !important;
        font-size: 10px;
        letter-spacing: 0.12em;
        white-space: nowrap;
        position: relative;
        justify-content: space-between;
        align-items: center;
        font-family: "Inter", sans-serif;
        span {
            opacity: 0.7;
        }
        .new-update-tag {
            opacity: 1; 
            position: relative;
            right: 0 !important;
            text-transform: capitalize !important;
            line-height: 30px;
        }
    }

    .second-child-list-icon {
        line-height: 25px !important;
    }
    
    .sideBack{
        background: ${props => props.sidebarTheme.backgroundColor || "#fff"};
        overflow: hidden;
        margin-bottom: ${props =>
          props.themeSetting.footerAlignValue === "above" ? "50px" : "0px"};
        margin-top: ${props =>
          props.themeSetting.toolbarAlignValue === "above" ? "65px" : "0px"};
        box-shadow: 1px 0 0 #e2e8f0;
    }

    .sidebar-wrapper{

        .nav-link {
            color: ${props => sidebarMenuTextColor(props)} !important;
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
            font-weight: 500;
            font-size: 13px;
            letter-spacing: -0.01em;

            p, span, i {
                color: inherit !important;
            }

            &:hover {
                padding-left: 20px !important;
                background: ${props => menuHighlightColor(props)} !important;
                border-radius: 10px;
                color: #ffffff !important;

                p, span, i {
                    color: #ffffff !important;
                }
            }

            &.active {
                background: ${props => menuHighlightColor(props)} !important;
                color: #ffffff !important;
                font-weight: 600;
                border-radius: 10px !important;
                box-shadow: 0 2px 8px rgba(16, 185, 129, 0.35);

                p, span, i {
                    color: #ffffff !important;
                }
            }
        }

        .arrow-sidebar {
            color: ${props => sidebarMenuTextColor(props)} !important;
        }
        
        .main-list {
            line-height: 30px;
            font-size: 14px;
            white-space: nowrap;
            position: relative;
            text-transform: capitalize;
            color: #fff;
            -webkit-transform: translateZ(0);
            -ms-transform: translateZ(0);
            transform: translateZ(0);
            display: block;
            height: auto;
            opacity: 1;
            transition: all .2s ease;
            p {
                span {
                    font-family: "muli-regular";
                }
            }
        }
    
        .child-list {
            margin: 0;
            line-height: 30px;
            font-size: 15px;
            font-weight: 400;
            white-space: nowrap;
            position: relative;
            color: #fff;
            -webkit-transform: translateZ(0);
            -ms-transform: translateZ(0);
            transform: translateZ(0);
            display: block;
            height: auto;
            opacity: 1;
            transition: all .15s linear;
        }

        .active-sidebar-type-class {
            border-left: 3px solid ${props =>
              props.themeSetting.sidebarTransParentValue === "on"
                ? props.themeSetting.sidebarTransParentActiveColor
                : props.sidebarTheme.style4VarientActiveTextColor} !important;
            .child-list {
                margin: 5px 7px 0 !important;
            }
        }

        .active-arrows {
            color: #ffffff !important;
        }
    
        .active {
            color: #ffffff !important;
            padding-left: ${props =>
              (props.themeSetting.activeLinkStyle === "style2" ||
                props.themeSetting.activeLinkStyle === "style3") &&
              "1.6rem"};

            background: ${props => menuHighlightColor(props)} !important;
            font-weight: 600;

            margin: ${props =>
              props.themeSetting.activeLinkStyle === "style2"
                ? "5px 0px 0 !important"
                : props.themeSetting.activeLinkStyle === "style3"
                ? "5px 10px 0 0 !important"
                : "5px 10px 0"};
            border-radius: 10px !important;
            box-shadow: 0 2px 8px rgba(16, 185, 129, 0.35);
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);

            .nav-link, p, span, i {
                color: #ffffff !important;
            }

            .new-update-tag {
                letter-spacing: 1px;
                color: white !important;
                background: #ff4081 !important;
            }
        }
    }

    .sidebar-header {
        cursor: pointer;
        position: relative;
        z-index: 4;
        padding: 12px 0.75rem;
        border-bottom: ${props =>
          isDarkSidebar(props)
            ? "1px solid rgba(255,255,255,0.08)"
            : "1px solid #f1f5f9"};
        background-color: ${props =>
          props.themeSetting.sidebarTransParentValue !== "on" &&
          props.sidebarTheme.header &&
          props.sidebarTheme.header};
        .simple-text {
            text-transform: capitalize;
            white-space: nowrap;
            font-size: 0.9rem;
            color: #000000;
            font-weight: 700;
            line-height: 30px;
            text-decoration: none;
            overflow: hidden;
            font-family: "Outfit", sans-serif;
        }
        .logo-mini {
            opacity: 1;
            float: left;
            text-align: center;
            margin-left: 8px;
            margin-right: 8px;
            padding: 0;
            text-decoration: none;

            .logo-img {
                background: #ffffff;
                border-radius: 10px;
                padding: 6px;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 44px;
                height: 44px;
                box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
            }

            img {
                width: 32px;
                height: 32px;
                object-fit: contain;
            }
        }
        .logo-text {
            display: block;
            opacity: 1;
            transform: translateZ(0px);
            padding: 9px 0px 8px;
            color: ${props =>
              isDarkSidebar(props)
                ? "#ffffff"
                : props.themeSetting.sidebarTransParentValue === "on"
                ? "white"
                : props.sidebarTheme.textColor} !important;
            font-weight: 600;
        }
    }

    .sidebar-whole-list {
        background: ${props => props.sidebarTheme.sideOpenListBackground} 
    }

    .new-update-tag {
        top: 0;
        position: absolute;
        right: 0;
        padding: 0px 10px;
        border-radius: 10px;
        letter-spacing: 1px;
        color: ${props =>
          props.themeSetting.sidebarTransParentValue === "on"
            ? "black"
            : props.sidebarTheme.activeRouteTextColor} !important;
        background: ${props =>
          props.themeSetting.sidebarTransParentValue === "on"
            ? "white"
            : props.sidebarTheme.activeRouteBackColor} !important;
    }
`;

export default SidebarWrapper;
